import React from 'react';

import Carousel from './slider/Carousel';

const Hero = () => {
  return (
  
   <Carousel />
 
  );
};

export default Hero;